<template>
  <div class="legacy">
    <Loader v-if="loading" />
    <template v-if="!loading && subscription.logs && !canUpgrade()">
        <div v-if="subscription.logs">
          <card class="box">
            <div class="overflow-hidden overflow-x-auto relative">
              <table class="table w-full" cellpadding="0" cellspacing="0">
                <thead>
                <tr>
                  <th class="text-left">{{ $t('Date') }}</th>
                  <th class="text-left">{{ $t('Event') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(log, index) in subscription.logs" :key="`tableRow_${index}`" class="none-hover">
                  <td>{{ $d(log.date * 1000, 'shortDate') }}</td>
                  <td>{{ $t(log.event) }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </card>
        </div>
    </template>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import Loader from '@/_legacy/components/Icons/Loader.vue';
  import authMixin from '@/_legacy/mixins/authMixin';

  export default {
    name: 'SubscriptionLogs',

    components: { Loader },

    mixins: [authMixin],

    data() {
      return {
        loading: true,
      };
    },

    computed: {
      ...mapGetters({
        subscription: 'subscription/subscription',
      }),
    },

    watch: {
      subscription() {
        if (!this.subscription) {
          this.$router.push({ name: 'planDetails' });
        }
        this.loading = false;
      },
    },

    async created() {
      this.loading = true;
      await this.getSubscription();
      this.loading = false;
    },

    methods: {
      ...mapActions({
        getSubscription: 'subscription/getSubscription',
      }),
    },
  };
</script>
